.governanceTitleContainer {
    display: flex;
    align-items: center;
    max-width: 600px;
}

.tooltipContainer {
    margin-left: 4px;
}
